import _default from './Image';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Image/index.js
// module id = 151
// module chunks = 0